module.exports = __webpack_public_path__ + "img/567.33b596d5.jpg";